import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatChipsModule } from "@angular/material/chips";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ConstantService } from "app/Shared/Services/constant-service";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { TableModule } from "primeng/table";
import { AuditTrailComponent } from "./audit-trail.componenet";
import { DialogModule } from "primeng/dialog";

@Component({
    selector: 'app-audit-trail-dialog',
    imports: [CommonModule, ButtonModule, MatTooltipModule, TableModule, MatExpansionModule,
        MatChipsModule, MatProgressSpinnerModule, MatChipsModule,MatExpansionModule,
        ConfirmDialogModule, FormsModule, AuditTrailComponent, DialogModule,
    ],
    template: `
          <p-dialog 
          header="Audit Trail History"
          id="audit-trail" 
          height="auto"
          [(visible)]="isOpenClose" 
          [modal]="false" 
          [maximizable]="true"
          [baseZIndex]="10000" 
          draggable="true" 
          [closable]="true" 
          (onHide)="closeDialogbox()" 
          [style]="{ width: '100%' ,}"
          [breakpoints]="{ '1199px': '75%' }"
          appendTo="body"
          styleClass="audit-trail-dialog">
          <div class="col-md-12 nopadding">
            <app-audit-trail 
                [SelectedRow]="selectedRow" [pageName]="pageName">
            </app-audit-trail>
          </div>

      <ng-template #footer>
            <button type="button" id="audit-trail-close"
            style="background: #e54a23 !important; border: none !important" pButton icon="fa fa-close" (click)="closeDialogbox()" label="Close" 
                class="ui-button-secondary userActionBtn close-button"></button>
          </ng-template>

          </p-dialog>
`,
    styles: [`
  .container {
                max-width: 100% !important;
                min-height: 350px !important;
                z-index: 1006 !important;
                opacity: 1 !important;
                }
  .close-button {
                  padding: 2.75px 11px 2.75px 11px;
                  font-family: "Roboto", "Trebuchet MS", Arial, Helvetica, sans-serif;
                  font-size: 11px !important;
                  font-weight: lighter !important;
                }   
  ::ng-deep .audit-trail-dialog .p-dialog-header .p-dialog-title {
                  font-size: 17.5px !important;
                  font-weight: 500 !important;
                  font-family: "Arial", serif !important; 
                  color: #1b1d1f;
                }                  
      `]
})
export class AuditTrailDialogComponent implements OnInit {
  @Output() closeEventDialog: EventEmitter<boolean> = new EventEmitter();
  @Input('SelectedRow') selectedRow: any = [];
  @Input('pageName') pageName: string | any;
  @Input('isAuditTrailOpen') isOpenClose: boolean = false;

  constructor(public constantService: ConstantService) {

  }
  closeDialogbox() {
    this.isOpenClose = false;
    this.closeEventDialog.emit(true);
  }
  ngOnInit() {
  }
}